import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { IQueryParams } from '../../../models/common/IQueryParams';
import { getFSMListResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import { getFSMList } from '../../actions/actionType/sources/FSMListType';
import { fetchAllFSMListFailure, getAllFSMListStarted, getAllFSMListSuccess } from '../../actions/sagaActions/sources/FSMListSagaActions';
import { FetchAllFSMListFailurePayload, FetchAllFSMListRequest, IFSMBusinessObj } from '../../actions/types/sources/GetFSMListTypes';

const headersInstance = () => ({
  'Ocp-Apim-Subscription-Key':
    process.env.REACT_APP_API_OCP_APIM_SUBSCRIPTION_KEY ?? ''
});
/**
 * Call Gets source registries by API
 * @returns api response
 */
export async function callGetAllFSMListApi(pageNo: number, item: number, queryParams?: IQueryParams, sort?: string) {
  const urlString = `${process.env.REACT_APP_API_CONTROL_PLANE_SOURCE_REGISTRY_URL}/business-objects/search?page=${pageNo}&size=${item}&sort=${sort || 'DESC'}`;
  const requestBody = queryParams ? {
    businessObjectName: queryParams.searchText,
    status: ['active'],
    businessObjectType: [],
    fromDate: queryParams.fromDate ? (queryParams.fromDate) : '',
    toDate: queryParams.toDate ? (queryParams.toDate) : '',
  } : {};
  return apiWrapper.post<IFSMBusinessObj>(
    urlString,
    requestBody,
    headersInstance()
  );
}

export function* getAllFSMRegistry({ pageNo, item, queryParams, sort }: FetchAllFSMListRequest) {
  yield put(getAllFSMListStarted());
  try {
    const { responseBody: data, isError, error } = yield call(callGetAllFSMListApi, pageNo, item, queryParams, sort);
    if (isError) {
      throw error;
    }
    const resValidity = getFSMListResponseSchema.validate(data, { abortEarly: true });
    if (resValidity.error) {
      throw new Error('No Response');
    } else {
      yield put(getAllFSMListSuccess(data));
    }
  } catch (error) {
    const obj: FetchAllFSMListFailurePayload = {
      error: String(error)
    };
    yield put(fetchAllFSMListFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchAllFSMListSaga() {
  yield takeLatest(getFSMList.FETCH_FSM_LIST_REQUEST, getAllFSMRegistry);
}

export const getAllFSMRegistriesSaga = [fork(fetchAllFSMListSaga)];
